import { PARTNER } from "@tm/isomorphic-utils";
import { FormattedText, ImageComponent, SpanTag } from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import { theme } from "@tm/utility/global";
import React from "react";

import { ORDER_DETAIL_V2_URLS } from "../../constants";
import {
  BreadcrumbBar,
  BreadcrumbSep,
  BreadcrumbText,
  Container,
  FormattedTextWrapper,
  Hero,
  HeroBgImage,
  HeroContentOverlay,
  HeroHeader,
  HeroImageWrapper,
  HeroTitle,
  HeroTitleWrap,
} from "../../OrderDetailV2.style";
import type { OrderDetailV2HeroProps } from "../../types";

export const OrderDetailV2Hero: React.FC<OrderDetailV2HeroProps> = ({
  bookingId,
  title,
  orderIdLabel,
  icon,
  backgroundImage,
  bgColor,
  showNav,
}: OrderDetailV2HeroProps) => {
  const context = usePartnerContext();
  const isGI = context === PARTNER.GI;
  const hasOverlayBg = isGI && !!backgroundImage;

  const heroContent = (
    <HeroHeader>
      <HeroTitleWrap>
        {showNav && !isGI && (
          <BreadcrumbBar>
            <BreadcrumbText
              as="a"
              href={ORDER_DETAIL_V2_URLS.MY_TRIPS}
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              My Trips
            </BreadcrumbText>
            <BreadcrumbSep>&gt;</BreadcrumbSep>
            <BreadcrumbText>Insurance</BreadcrumbText>
          </BreadcrumbBar>
        )}

        <HeroTitle>
          <SpanTag
            fontSize="xlarge"
            fontWeight={isGI ? "bold" : "black"}
            color={isGI ? theme.whiteText : theme.blackText}
            style={isGI ? { fontWeight: 600 } : undefined}
          >
            {title}
          </SpanTag>
          <SpanTag
            fontSize="xs"
            color={isGI ? theme.whiteText : theme.greyText7}
          >
            <FormattedTextWrapper
              textColor={isGI ? theme.whiteText : undefined}
            >
              <FormattedText value={{ html: orderIdLabel }} baseStyle={{}} />
            </FormattedTextWrapper>
          </SpanTag>
        </HeroTitle>
      </HeroTitleWrap>
      {!isGI && backgroundImage && (
        <HeroImageWrapper>
          <ImageComponent src={backgroundImage} width="440px" height="160px" />
        </HeroImageWrapper>
      )}
    </HeroHeader>
  );

  return (
    <Hero bgColor={bgColor} hasOverlayBg={hasOverlayBg}>
      {hasOverlayBg ? (
        <>
          <HeroBgImage src={backgroundImage} alt="" />
          <HeroContentOverlay>
            <Container>{heroContent}</Container>
          </HeroContentOverlay>
        </>
      ) : (
        <Container>{heroContent}</Container>
      )}
    </Hero>
  );
};
